/* eslint-disable react/no-unescaped-entities */
import { memo } from 'react'
import { Link } from '@mui/material'
import { useClientDetails } from 'stores/utils/hooks/useClientDetails'
import useEmotionStyles from 'hooks/useEmotionStyles'
import CategoryLayout from 'components/Layout/Category'

const styles = () => ({
  paragraph: {
    color: 'rgb(45, 55, 72)',
    lineHeight: '1.25rem',
    fontSize: '.8125rem'
  }
})

const Agb = () => {
  const clientDetails = useClientDetails()

  const { paragraph } = useEmotionStyles(styles)

  return (
    <CategoryLayout>
      <>
        <p className={paragraph}>
          Mit Klicken des "Weiter"-Buttons erteile ich FINANZCHECK einen
          kostenlosen Kreditvergleichsauftrag und akzeptiere die{' '}
          <Link
            href={clientDetails?.urls?.termsAndConditions}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontWeight: 700 }}
          >
            AGB
          </Link>
          . Die{' '}
          <Link
            href={clientDetails?.urls?.precontractual}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontWeight: 700 }}
          >
            Pflichtinformationen
          </Link>{' '}
          und die{' '}
          <Link
            href={clientDetails?.urls?.dataProtection}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontWeight: 700 }}
          >
            Datenschutzhinweise
          </Link>{' '}
          habe ich erhalten.
        </p>
      </>
    </CategoryLayout>
  )
}
export default memo(Agb)
